<template>
  <div class="overlay" v-if="isVisible">
    <div class="adminAssignStudentsPopUp">
      <b class="assignStudents"
        >Assign {{ student.firstName }} {{ student.lastName }} To Class</b
      >
      <div class="row" style="width: 100%">
        <div class="col-sm-20 headerText">Instructor</div>
        <div class="col-sm-20 headerText">Class</div>
        <div class="col-sm-20 headerText">Duration</div>
        <div class="col-sm-20 headerText">Size</div>
      </div>
      <div
        class="row"
        style="width: 100%"
        v-for="classObj of classes"
        v-bind:key="classObj.id"
      >
        <div class="col-sm-20 align-content-center">
          {{ classObj.activeInstructor.user.firstName }}
          {{ classObj.activeInstructor.user.lastName }}
        </div>
        <div class="col-sm-20 align-content-center">
          {{ classObj.curriculum.program.name }} Pilot
        </div>
        <div class="col-sm-20 align-content-center">
          {{ classObj.activeInstructor.user.firstName }}
          {{ classObj.activeInstructor.user.lastName }}
        </div>
        <div class="col-sm-20 align-content-center">
          {{ classObj.activeInstructor.user.firstName }}
          {{ classObj.activeInstructor.user.lastName }}
        </div>
        <div class="col-sm-20 text-center align-content-center">
          <button
            class="assignWrapper"
            @click="assignStudentToClass(classObj.id)"
          >
            Assign
          </button>
        </div>
      </div>
      <button class="addClassWrapper" @click="openNewClass">Add Class</button>
      <img
        @click="closeModal"
        class="vectorIcon"
        alt=""
        src="/static/img/grey-x.svg"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "AdminAssignStudentsPopUp",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    student: {
      type: Object,
      required: true,
    },
    classes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    openNewClass() {
      this.closeModal();
      this.$emit("new");
    },
    assignStudentToClass(classId) {
      this.$emit("assign", { classId, studentId: this.student.id });
      this.closeModal();
    },
  },
};
</script>
<style scoped>
.col-sm-20 {
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}
.headerText {
  color: rgba(64, 64, 64, 0.5);
}
.assignStudents {
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.assignWrapper {
  border-radius: 5px;
  background-color: #3171e2;
  padding: 8px 20px;
  text-align: center;
  font-size: 15px;
  color: #fff;
}
.addClassWrapper {
  align-self: stretch;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  z-index: 2;
  text-align: center;
  color: #fff;
  font-size: 15px;
}
.vectorIcon {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.adminAssignStudentsPopUp {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
</style>
